import { Button, Stack } from "@mui/material";
import React from "react";
import { ReactSelectOption } from "../../interfaces";
import { useLazyGetFoldersQuery } from "../../redux/services";
import { ConvertToReactSelect } from "../../utils";
import { SelectBox } from "../reactSelect";
import { useSnackbar } from "notistack";

export const ImportFromFolderTemplate: React.FC<{ onImportClicked: (templateId: string) => void }> = ({ onImportClicked }) => {

    const { enqueueSnackbar } = useSnackbar();

    const [fetchFolderTemplates, folderTemplateData] = useLazyGetFoldersQuery();

    const [fetching, setFetching] = React.useState<boolean>(false);
    const [importFromFolder, setImportFromFolder] = React.useState<ReactSelectOption>();
    const [isError, setIsError] = React.useState<boolean>(false);

    const loadOption = async () => {
        setFetching(true);
        let options: any[] = [];

        const { data: templateParent } = await fetchFolderTemplates({ sequence_id: 'F-000002' }).unwrap();

        if (Array.isArray(templateParent)) {
            const allTemplates = await fetchFolderTemplates({
                parent_object_id: templateParent[0]._id,
                parent_object_type: 'folder',
                sort_by: 'folder_name',
                sort_order: 'asc',
                page_size: 10000
            }).unwrap();

            if (Array.isArray(allTemplates?.data ?? [])) {
                options = ConvertToReactSelect(allTemplates?.data ?? [], '_id', 'folder_name');
            }
        }

        setFetching(false);
        return { options: options, hasMore: options.length === 50 }
    };

    const importBtnClicked = () => {
        if (!importFromFolder) {
            setIsError(true);
            enqueueSnackbar("Please select a template to import", { variant: "error" });
            return;
        }

        onImportClicked(`${importFromFolder?.value ?? ''}`);
    }

    return <Stack gap={2}>
        <SelectBox
            id={"import-from-folder-module-option"}
            isPaginate
            loadOptions={() => loadOption()}
            label={"Folder Templates"}
            isRequired
            error={isError}
            helperText="Select a folder template to import"
            loading={folderTemplateData.isLoading || folderTemplateData.isFetching || fetching}
            value={importFromFolder}
            options={[]}
            onChange={(data: ReactSelectOption) => {
                setIsError(false);
                setImportFromFolder(data)
            }}
            isMenuFixed
        />

        <Button fullWidth color="primary" variant="contained" onClick={() => importBtnClicked()}>Import Template</Button>
    </Stack>
}